module.exports = __webpack_public_path__ + "frontend/img/icon-savings-xs.78817ca2.svg";